<template>
  <div>
    <div class="flex flex-col pt-6 pb-12">
      <span class="text-3xl font-semibold text-center">{{ data.grade }} {{ data.total_score }}</span>
      <span class="text-center mt-3">Total Score (Assessment)</span>
    </div>
    <div class="grid grid-cols-4 gap-8">
      <div
        v-for="(item, index) of card"
        class="flex flex-col bg-white rounded-2xl py-13"
        :key="index"
      >
        <span class="text-center text-secondary text-4xl font-semibold">{{ item.value }}</span>
        <span class="text-center mt-3">{{ item.label }}</span>
        <span class="text-center text-grey-001 text-sm mt-1">{{ item.unit }}</span>
      </div>
      <div
        v-for="(item, index) of cardWithInput"
        class="flex flex-col justify-between bg-white rounded-2xl p-5 pb-8"
        :key="index+card.length"
      >
        <div class="flex flex-row justify-between">
          {{ item.label }}
          <div
            v-if="isEditable() && isUserCanAccessMenu(permission.name, 'edit')"
            class="mb-1 bg-secondary-accent rounded-lg"
            :class="[item.isEdit ? 'bg-icon-success' : 'bg-icon']"
            @click="item.isEdit ? saveCompanyPerformance(index) : item.isEdit = true"
          >
            <img :src="require(`@/assets/shipo-icon-edit${item.isEdit ? '-check-list' : ''}.svg`)">
          </div>
        </div>
        <div class="flex flex-row">
          <autonumeric
            v-model="item.value"
            class="flex-grow"
            :options="numberOptions"
            :disabled="!item.isEdit"
          >
            <div class="h-full px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">point</span>
            </div>
          </autonumeric>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Autonumeric from '@/components/autonumeric'
export default {
  components: {
    Autonumeric
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    filter: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      companyId: 'BargePerformance/companyId'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.card.forEach(item => {
            item.value = val[item.key]
          })
          this.cardWithInput.forEach(item => {
            item.value = val[item.key].value
          })
        }
      }
    }
  },
  data() {
    return {
      isEdit: false,
      card: [
        {
          key: 'sailing_performance',
          label: 'Sailing Performance',
          unit: 'Point',
          value: 0
        },
        {
          key: 'breakdown_issue',
          label: 'Breakdown Issue',
          unit: 'Point',
          value: 0
        },
        {
          key: 'incident_issue',
          label: 'Incident Issue',
          unit: 'Point',
          value: 0
        },
        {
          key: 'waiting_certificate',
          label: 'Waiting Certificate',
          unit: 'Point',
          value: 0
        },
        {
          key: 'grounded',
          label: 'Near/Miss Grounded',
          unit: 'Point',
          value: 0
        }
      ],
      cardWithInput: [
        {
          key: 'daily_reporting',
          label: 'Daily Reporting',
          type: 'DAILY_REPORTING',
          isEdit: false,
          value: 0
        },
        {
          key: 'communication_coordination',
          label: 'Communication & Coordination',
          type: 'COMMUNICATION_COORDINATION',
          isEdit: false,
          value: 0
        }
      ],
      numberOptions: {
        allowDecimalPadding: false,
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        minimumValue: '0'
      }
    }
  },
  methods: {
    async saveCompanyPerformance(index) {
      try {
        if (!!(!!this.filter.month ^ !!this.filter.years)) {
          this.showWarningNotification(this, 'Please fill out both month and year fields')
          return
        }
        const payload = {
          company_id: this.$route.params.id || this.companyId,
          type: this.cardWithInput[index].type,
          value: this.cardWithInput[index].value,
          ...this.filter
        }
        await this.$store.dispatch('BargePerformance/postCompanyPerformance',
          Object.keys(payload)
            .filter(key => !!payload[key])
            .reduce((item, key) => {
              item[key] = payload[key]
              return item
            }, {})
        )
        this.cardWithInput[index].isEdit = false
        this.showSuccessNotification(this, 'You have successfully input value')
      } catch (e) {
        this.showFailedNotification(this, `Failed to save ${this.startCase(type)}, please try again`)
      }
    },
    isEditable() {
      if (!!this.filter.month && !!this.filter.years) {
        return this.moment(
          `${ this.filter.month }-${ this.filter.years }`, ['MM-YYYY']
        ) > this.moment().subtract(2, 'months')
      }
      return !this.filter.month && !this.filter.years
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-secondary-accent {
  background-color: rgba(252, 219, 208, 0.45) !important;
}

.py-13 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
</style>
